import React from 'react';
import Icon from '../../../components/AppIcon';

const ROIOverview = ({ data }) => {
  const metrics = [
    { label: 'Total Leads', value: data?.totalLeads?.toLocaleString() || '0', icon: 'Users', color: 'text-blue-600', bg: 'bg-blue-50' },
    { label: 'Converted Leads', value: data?.convertedLeads?.toLocaleString() || '0', icon: 'Trophy', color: 'text-green-600', bg: 'bg-green-50' },
    { label: 'Conversion Rate', value: `${data?.conversionRate || 0}%`, icon: 'TrendingUp', color: 'text-purple-600', bg: 'bg-purple-50' },
    { label: 'Total Revenue', value: `$${(data?.totalRevenue || 0)?.toLocaleString()}`, icon: 'DollarSign', color: 'text-emerald-600', bg: 'bg-emerald-50' },
    { label: 'ROI', value: `${data?.roi || 0}%`, icon: 'BarChart3', color: 'text-orange-600', bg: 'bg-orange-50' },
    { label: 'Active Campaigns', value: data?.activeCampaigns?.toString() || '0', icon: 'Send', color: 'text-indigo-600', bg: 'bg-indigo-50' }
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {metrics?.map((metric, index) => (
          <div key={index} className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
            <div className="flex items-center space-x-4">
              <div className={`p-3 rounded-lg ${metric?.bg}`}>
                <Icon name={metric?.icon} size={24} className={metric?.color} />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">{metric?.label}</p>
                <p className="text-2xl font-bold text-foreground">{metric?.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      {!data && (
        <div className="bg-card border border-border rounded-lg p-12 text-center">
          <Icon name="BarChart3" size={48} className="text-muted-foreground mx-auto mb-4 opacity-40" />
          <p className="text-muted-foreground">No ROI data available yet. Start adding leads and campaigns to track your ROI.</p>
        </div>
      )}
    </div>
  );
};

export default ROIOverview;